import { render, staticRenderFns } from "./cv-search_backup.vue?vue&type=template&id=23f4984a"
import script from "./cv-search_backup.vue?vue&type=script&lang=js"
export * from "./cv-search_backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports